import React, { useEffect, useRef, useState } from "react";
import styles from "./Carouselmobile.module.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const CarouselMobile = () => {
  const spinRef = useRef(null);
  const [rotation, setRotation] = useState(0);

  const radius = 170; // slightly smaller for mobile
  const imgWidth = 180;
  const imgHeight = 300;
  const rotateStep = 120; // 360 / 3 images = 120 degrees

  const rotateImages = (direction) => {
    setRotation((prev) =>
      direction === "next" ? prev - rotateStep : prev + rotateStep
    );
  };

  useEffect(() => {
    const ospin = spinRef.current;
    const aEle = [...ospin.getElementsByTagName("a")];

    ospin.style.width = `${imgWidth}px`;
    ospin.style.height = `${imgHeight}px`;
    ospin.style.position = "relative";
    ospin.style.transformStyle = "preserve-3d";

    // Arrange images in a circle
    aEle.forEach((ele, i) => {
      ele.style.width = `${imgWidth}px`;
      ele.style.height = `${imgHeight}px`;
      ele.style.position = "absolute";
      ele.style.transform = `rotateY(${i * rotateStep}deg) translateZ(${radius}px)`;
      ele.style.transition = "transform 1s";
    });

    // Apply rotation when state changes
    ospin.style.transform = `rotateY(${rotation}deg)`;
  }, [rotation]);

  return (
    <div className={styles.bodyy}>
      <div className={styles.dragContainer}>
        <div className={styles.spinContainer} ref={spinRef}>
          <Link to="/checkOutForm?course=UI-UX" rel="noopener noreferrer">
            <img src="/UI-UX1.png" alt="UI/UX course" />
          </Link>
          <Link to="/checkOutForm?course=WebDev" rel="noopener noreferrer">
            <img src="/Web-Dev5.png" alt="Web Development course" />
          </Link>
          <Link to="/checkOutForm?course=AppDev" rel="noopener noreferrer">
            <img src="/App-Dev1.png" alt="App Development course" />
          </Link>
        </div>

        {/* Controls */}
        <div className={styles.controls}>
          <button
            className={styles.buttonn}
            onClick={() => rotateImages("back")}
          >
            <FaArrowLeft />
          </button>
          <button
            className={styles.buttonn}
            onClick={() => rotateImages("next")}
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarouselMobile;
